module.exports = __webpack_public_path__ + "media/app/assets/classes/monk-845349889d6e14ec4082872eaf02fb2a.jpg";